import script from "./QuizCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizCard.vue?vue&type=script&setup=true&lang=ts"

import "./QuizCard.vue?vue&type=style&index=0&id=eb7f568a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb7f568a"]])

export default __exports__